export default function PHP_fetch_assoc() {
  return (
    <div>
      <h1>PHP_fetch_assoc</h1>
    </div>
  );
}
